import styled from 'styled-components';

export const MonthlyReportsAtPartnerWrapper = styled.div`
.back-link {
    img {
      margin-inline-end: 10px;
      transform: ${({ltr}) => ltr ? 'rotate(180deg)' : ''}
    }
  }
`